import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Box } from '@mui/material';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import SchemaRoundedIcon from '@mui/icons-material/SchemaRounded';
import BigButton from '../../Components/Inputs/BigButton';
import LoadsHistory from './Components/LoadsHistory';
// import WaveConfiguration from './Components/WaveConfiguration';
import WaveFilters from './Components/WaveFilters';
import StagedImports from './Components/StagedImports';
import { FullSizeCenteredFlexBox } from '../../Components/FlexBox';

const WaveManagement = function WaveManagement({
  // heightQuery = true,
  userRoles = [],
}) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const isSuperAdmin = userRoles.find((role) => role.roleId === 'SUPERADMIN');

  const [showLoadsHistory, setShowLoadsHistory] = useState(false);
  const [showWaveConfig, setShowWaveConfigs] = useState(false);
  const [showWaveFilters, setShowWaveFilters] = useState(false);

  const handleShowLoadsHistory = () => setShowLoadsHistory(true);
  const handleCloseLoadsHistory = () => setShowLoadsHistory(false);
  const handleShowWaveConfig = () => setShowWaveConfigs(true);
  const handleCloseWaveConfig = () => setShowWaveConfigs(false);
  const handleShowWaveFilters = () => setShowWaveFilters(true);
  const handleCloseWaveFilters = () => setShowWaveFilters(false);

  const noneOpen = !showLoadsHistory && !showWaveConfig && !showWaveFilters;

  return (
    <>
      {showWaveConfig && (
        <StagedImports show={showWaveConfig} close={handleCloseWaveConfig} />
      )}
      {/* <WaveConfiguration show={showWaveConfig} close={handleCloseWaveConfig} /> */}
      {showLoadsHistory && (
        <LoadsHistory show={showLoadsHistory} close={handleCloseLoadsHistory} />
      )}
      {showWaveFilters && (
        <WaveFilters show={showWaveFilters} close={handleCloseWaveFilters} />
      )}
      {noneOpen && (
        <FullSizeCenteredFlexBox justifyContent="center">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '48px',
              flexWrap: 'wrap',
              p: '24px',
            }}
          >
            <BigButton
              title={t('LOADING_FILES')}
              subtitle={t('LOADS_HISTORY_AND_LOADING')}
              onClick={handleShowLoadsHistory}
              width="620px"
              bgcolor="#7e91dd"
              icon={
                <UploadFileRoundedIcon
                  sx={{ color: '#314cb6', fontSize: 43 }}
                />
              }
            />
            <BigButton
              title={t('WAVE_CONFIGS')}
              subtitle={t('WAVE_SETTINGS_MANAGEMENT')}
              onClick={handleShowWaveConfig}
              width="620px"
              bgcolor="#eac2de"
              icon={
                <SettingsRoundedIcon sx={{ color: '#b43e8f', fontSize: 43 }} />
              }
            />
            {isSuperAdmin && (
              <BigButton
                title={t('WAVE_FILTERS')}
                subtitle={t('WAVE_FILTERS_SUBTITLE')}
                onClick={handleShowWaveFilters}
                width="620px"
                bgcolor="#cfe8d8"
                icon={
                  <SchemaRoundedIcon sx={{ color: '#2e7d32', fontSize: 43 }} />
                }
              />
            )}
          </Box>
        </FullSizeCenteredFlexBox>
      )}
    </>
  );
};

WaveManagement.propTypes = {
  heightQuery: PropTypes.bool,
};

export default WaveManagement;
